import { useFormik } from 'formik';
import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import InputTextJSX from './InputTextJSX';
import TextAreaJSX from './TextAreaJSX';
import InputDateJSX from './InputDateJSX';
import { toast } from 'react-toastify';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import Beatloader from '../../../../../Common/Loaders/Beatloader';

const AEDirectMAWBDownloadOptionsModal = ({
    show,
    handleClose,
    token,
    user_id,
    id,
    mawb_number,
    DirectMAWBData,
    loadingDirectMAWBData
}) => {
    const [destnOptnAirport, setDestnOptnAirport] = useState(false);
    const [originOptnAirport, setOriginOptnAirport] = useState(false);
    const [shipperThisName, setShipperThisName] = useState(false);
    const [thisAccntNum, setThisAccntNum] = useState(false);
    const [thisHandlingInfo, setThisHandlingInfo] = useState(true);
    const [disableSubmit, setDisableSubmit] = useState(false);

    // const initialValues = 

    const formik = useFormik({
        initialValues: {
            as_agreed: "FREIGHT",
            issuing_carrier_agent_name: "",
            issuing_carrier_agent_address: "",
            agent_iata_code: "",
            loading_port_code: "",
            issuing_carrier_agent_name_option: "sub_agent_name",
            is_print_dest_code_with_name: false,
            dstn_port_opt: "city",
            dstn_airport: "",
            shipper_agent_name: "dont_print",
            shipper_this_name: "",
            agent_accnt_num: "dont_print",
            this_account_num: "",
            is_nature_qty_of_goods: true,
            is_print_shipper_phone: false,
            is_print_shipper_fax: false,
            is_print_shipper_email: false,
            is_print_consignee_phone: false,
            is_print_consignee_fax: false,
            is_print_consignee_email: false,
            is_print_notify_phone: false,
            is_print_notify_fax: false,
            is_print_notify_email: false,
            is_shipper_name_checked: true,
            shipper_name: "",
            is_shipper_address_checked: true,
            shipper_address: "",
            is_consignee_name_checked: true,
            consignee_name: "",
            is_consignee_address_checked: true,
            consignee_address: "",
            is_notify1_name_checked: false,
            notify1_name: "",
            is_notify1_address_checked: false,
            notify1_address: "",
            is_notify2_name_checked: false,
            notify2_name: "",
            is_notify2_address_checked: false,
            notify2_address: "",
            chargeCode: "none",
            is_print_other_charge_in_decimal: false,
            is_print_clubbed_charges_in_master: false,
            notify_check_box: "notify_accnt_info_box",
            is_print_remarks_below_rating: true,
            is_print_vol_with_dim: false,
            is_print_executed_at: false,
            is_print_airway_bill_num: true,
            is_print_this_handling_info: true,
            handling_info: "",
            is_print_setting_eap: false,
            is_print_setting_eaw: false,
            dimension_handling_info_box: "dimension_below_goods_box",
            origin_port_opt: "city",
            origin_airport: "",
            mawb_issued_party: "",
            mawb_issued_city: "",
        },
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            let config = { headers: { 'auth-token': token, user_id: user_id }, responseType: 'blob', };
            try {
                values.id = id;
                if (!values.is_print_this_handling_info) {
                    values.handling_info = ""
                }
                axios.post(`${adminMainUrl}/api/freight/forwarding/air/export/direct-shipment/mawb/download-post`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            const blob = new Blob([response.data], { type: 'application/pdf' });
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', `FF_AE_DIRECT_MAWB_${mawb_number}.pdf`);
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            setDisableSubmit(false);
                        } else {
                            toast.error(response.error.message);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        toast.error(error.message);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    // console.log('data', DirectMAWBData)
    // useEffect(() => {
    //     console.log("value", formik.values)
    // }, [formik])

    useEffect(() => {
        if (DirectMAWBData) {
            // formik.setValues({
            //     issuing_carrier_agent_name: DirectMAWBData?.getFFMAWB?.issuing_carrier_agent_name ?? "",
            //     issuing_carrier_agent_address: DirectMAWBData?.getFFMAWB?.issuing_carrier_agent_address ?? "",
            //     agent_iata_code: DirectMAWBData?.getFFMAWB?.agent_iata_code ?? "",
            //     handling_info: DirectMAWBData?.getFFMAWB?.handling_info ?? "",
            //     consignee_address: DirectMAWBData?.consignee_address ?? "",
            //     shipper_address: DirectMAWBData?.shipper_address ?? "",

            // })
            formik.resetForm();
            formik.setFieldValue("issuing_carrier_agent_name", DirectMAWBData?.getFFMAWB?.issuing_carrier_agent_name)
            formik.setFieldValue("issuing_carrier_agent_address", DirectMAWBData?.getFFMAWB?.issuing_carrier_agent_address)
            formik.setFieldValue("agent_iata_code", DirectMAWBData?.getFFMAWB?.agent_iata_code)
            formik.setFieldValue("handling_info", DirectMAWBData?.getFFMAWB?.handling_info)
            formik.setFieldValue("consignee_name", DirectMAWBData?.getConsigneeInfo)
            formik.setFieldValue("shipper_name", DirectMAWBData?.getShipperInfo)
            formik.setFieldValue("consignee_address", DirectMAWBData?.consignee_address)
            formik.setFieldValue("shipper_address", DirectMAWBData?.shipper_address)
        }
    }, [DirectMAWBData])




    return (
        <>
            <Modal
                show={show}
                onHide={handleClose}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Print Air Way Bill
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="card">
                        <div className="card-body">
                          {loadingDirectMAWBData?
                          <Beatloader/>
                          :
                            <form onSubmit={formik.handleSubmit}>

                                <div className="row">
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Airway Bill Print Setting</h4>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input_box_section ">
                                            <label
                                                for="basicpill-firstname-input"
                                                className="form-label"
                                            >
                                                Issuing Carrier's Agent Name 
                                            </label>
                                            <input
                                                type="text"
                                                name="issuing_carrier_agent_name"
                                                className="form-control form-control-sm"
                                                placeholder="Enter Issuing Carrier's Agent Name"
                                                value={formik?.values?.issuing_carrier_agent_name}
                                                onChange={formik?.handleChange}
                                                onBlur={formik?.handleBlur}

                                                onKeyPress={(event) => {
                                                    const inputValue = event.target.value;
                                                    if (
                                                        inputValue.length === 0 &&
                                                        event.key === " "
                                                    ) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                            />
                                            {formik?.touched.issuing_carrier_agent_name &&
                                                formik?.errors.issuing_carrier_agent_name ? (
                                                <div className="error">
                                                    {formik?.errors.issuing_carrier_agent_name}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input_box_section ">
                                            <label
                                                for="basicpill-firstname-input"
                                                className="form-label"
                                            >
                                                Issuing Carrier's Agent Address 
                                            </label>
                                            <input
                                                type="text"
                                                name="issuing_carrier_agent_address"
                                                className="form-control form-control-sm"
                                                placeholder="Enter Issuing Carrier's Agent Address"
                                                value={formik?.values?.issuing_carrier_agent_address}
                                                onChange={formik?.handleChange}
                                                onBlur={formik?.handleBlur}

                                                onKeyPress={(event) => {
                                                    const inputValue = event.target.value;
                                                    if (
                                                        inputValue.length === 0 &&
                                                        event.key === " "
                                                    ) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                            />
                                            {formik?.touched.issuing_carrier_agent_address &&
                                                formik?.errors.issuing_carrier_agent_address ? (
                                                <div className="error">
                                                    {formik?.errors.issuing_carrier_agent_address}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input_box_section ">
                                            <label
                                                for="basicpill-firstname-input"
                                                className="form-label"
                                            >
                                                Agent IATA Code 
                                            </label>
                                            <input
                                                type="text"
                                                name="agent_iata_code"
                                                className="form-control form-control-sm"
                                                placeholder="Enter Agent IATA Code"
                                                value={formik?.values?.agent_iata_code}
                                                onChange={formik?.handleChange}
                                                onBlur={formik?.handleBlur}

                                                onKeyPress={(event) => {
                                                    const inputValue = event.target.value;
                                                    if (
                                                        inputValue.length === 0 &&
                                                        event.key === " "
                                                    ) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                            />
                                            {formik?.touched.agent_iata_code &&
                                                formik?.errors.agent_iata_code ? (
                                                <div className="error">
                                                    {formik?.errors.agent_iata_code}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input_box_section ">
                                            <label
                                                for="basicpill-firstname-input"
                                                className="form-label"
                                            >
                                                Port Of Loading Code 
                                            </label>
                                            <input
                                                type="text"
                                                name="loading_port_code"
                                                className="form-control form-control-sm"
                                                placeholder="Enter Port Of Loading Code"
                                                value={formik?.values?.loading_port_code}
                                                onChange={formik?.handleChange}
                                                onBlur={formik?.handleBlur}

                                                onKeyPress={(event) => {
                                                    const inputValue = event.target.value;
                                                    if (
                                                        inputValue.length === 0 &&
                                                        event.key === " "
                                                    ) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                            />
                                            {formik?.touched.loading_port_code &&
                                                formik?.errors.loading_port_code ? (
                                                <div className="error">
                                                    {formik?.errors.loading_port_code}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>



                                </div>
                                <div className="row">
                                    <div className="col-md-5 row">


                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Issuing Carrier's Agent Name Option</h4>
                                        </div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="own_name" id="own_name" onChange={() => { formik.setFieldValue("issuing_carrier_agent_name_option", "own_name") }} checked={formik.values.issuing_carrier_agent_name_option === "own_name"} /> <label className="form-label" htmlFor='own_name'>Own Name</label></div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="sub_agent_name" id="sub_agent_name" onChange={() => { formik.setFieldValue("issuing_carrier_agent_name_option", "sub_agent_name") }} checked={formik.values.issuing_carrier_agent_name_option === "sub_agent_name"} /> <label className="form-label" htmlFor='sub_agent_name'>Sub Agent Name</label></div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="shipper_name" id="shipper_name" onChange={() => { formik.setFieldValue("issuing_carrier_agent_name_option", "shipper_name") }} checked={formik.values.issuing_carrier_agent_name_option === "shipper_name"} /> <label className="form-label" htmlFor='shipper_name'>Shipper Name</label></div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="iata_agent_name" id="iata_agent_name" onChange={() => { formik.setFieldValue("issuing_carrier_agent_name_option", "iata_agent_name") }} checked={formik.values.issuing_carrier_agent_name_option === "iata_agent_name"} /> <label className="form-label" htmlFor='iata_agent_name'>IATA Agent Name</label></div>


                                    </div>
                                    <div className="col-md-3">
                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Print Option</h4>
                                        </div>

                                        <input type="checkbox" className="mx-2" name="is_print_dest_code_with_name" id="is_print_dest_code_with_name"
                                            checked={formik.values.is_print_dest_code_with_name}
                                            onChange={(e) => formik.setFieldValue("is_print_dest_code_with_name", e.target.checked)} />
                                        <label htmlFor="is_print_dest_code_with_name" className="form-label">Print Destination Code With Name</label>
                                    </div>
                                    <div className="col-md-4 row">


                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Dstn. Port Option</h4>
                                        </div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="city" id="city" onChange={() => { formik.setFieldValue("dstn_port_opt", "city"); setDestnOptnAirport(false) }} checked={formik.values.dstn_port_opt === "city"} /> <label className="form-label" htmlFor='city'>City</label></div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="airport" id="airport" onChange={() => { formik.setFieldValue("dstn_port_opt", "airport"); setDestnOptnAirport(true) }} checked={formik.values.dstn_port_opt === "airport"} /> <label className="form-label" htmlFor='airport'>Airport</label></div>
                                        {/* {destnOptnAirport && */}
                                        <div className="col-md-12">
                                            <div className="input_box_section ">
                                                {/* <label
                                                        for="basicpill-firstname-input"
                                                        className="form-label"
                                                    >
                                                        Port Of Loading Code 
                                                    </label> */}
                                                <input
                                                    disabled={formik.values.dstn_port_opt != 'airport'}
                                                    type="text"
                                                    name="dstn_airport"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Airport Name"
                                                    value={formik?.values?.dstn_airport}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.dstn_airport &&
                                                    formik?.errors.dstn_airport ? (
                                                    <div className="error">
                                                        {formik?.errors.dstn_airport}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        {/* } */}

                                    </div>


                                </div>
                                <div className="row">
                                    <div className="col-md-4 row">


                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Shipper or His Agent's Name</h4>
                                        </div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="dont_print" id="dont_print" onChange={() => { formik.setFieldValue("shipper_agent_name", "dont_print"); setShipperThisName(false) }} checked={formik.values.shipper_agent_name === "dont_print"} /> <label className="form-label" htmlFor='dont_print'>Don't Print</label></div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="ask_while_printing" id="ask_while_printing" onChange={() => { formik.setFieldValue("shipper_agent_name", "ask_while_printing"); setShipperThisName(false) }} checked={formik.values.shipper_agent_name === "ask_while_printing"} /> <label className="form-label" htmlFor='ask_while_printing'>Ask While Printing</label></div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="use_this_name" id="use_this_name" onChange={() => { formik.setFieldValue("shipper_agent_name", "use_this_name"); setShipperThisName(false) }} checked={formik.values.shipper_agent_name === "use_this_name"} /> <label className="form-label" htmlFor='use_this_name'>Use This Name</label></div>
                                        {/* {shipperThisName && */}
                                        <div className="col-md-6">
                                            <div className="input_box_section ">
                                                {/* <label
                                                        for="basicpill-firstname-input"
                                                        className="form-label"
                                                    >
                                                        Port Of Loading Code 
                                                    </label> */}
                                                <input
                                                    disabled={formik.values.shipper_agent_name != "use_this_name"}
                                                    type="text"
                                                    name="shipper_this_name"
                                                    className="form-control form-control-sm"
                                                    // placeholder="Enter Port Of Loading Code"
                                                    value={formik?.values?.shipper_this_name}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.shipper_this_name &&
                                                    formik?.errors.shipper_this_name ? (
                                                    <div className="error">
                                                        {formik?.errors.shipper_this_name}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        {/* } */}

                                    </div>
                                    <div className="col-md-4 row">


                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Agent's A/C No</h4>
                                        </div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="dont_print" id="dont_print" onChange={() => { formik.setFieldValue("agent_accnt_num", "dont_print"); setThisAccntNum(false) }} checked={formik.values.agent_accnt_num === "dont_print"} /> <label className="form-label" htmlFor='dont_print'>Don't Print</label></div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="use_this_account" id="use_this_account" onChange={() => { formik.setFieldValue("agent_accnt_num", "use_this_account"); setThisAccntNum(true) }} checked={formik.values.agent_accnt_num === "use_this_account"} /> <label className="form-label" htmlFor='use_this_account'>Use This Account</label></div>
                                        {/* {thisAccntNum && */}
                                        <div className="col-md-12">
                                            <div className="input_box_section ">
                                                {/* <label
                for="basicpill-firstname-input"
                className="form-label"
            >
                Port Of Loading Code 
            </label> */}
                                                <input
                                                    disabled={formik.values.agent_accnt_num != "use_this_account"}
                                                    type="text"
                                                    name="this_account_num"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Account Number"
                                                    value={formik?.values?.this_account_num}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.this_account_num &&
                                                    formik?.errors.this_account_num ? (
                                                    <div className="error">
                                                        {formik?.errors.this_account_num}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        {/* } */}

                                    </div>
                                    <div className="col-md-4">
                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Nature and Quantity Of goods</h4>
                                        </div>

                                        <input type="checkbox" className="mx-2" name="is_nature_qty_of_goods" id="is_nature_qty_of_goods"
                                            checked={formik.values.is_nature_qty_of_goods}
                                            onChange={(e) => formik.setFieldValue("is_nature_qty_of_goods", e.target.checked)} />
                                        <label htmlFor="is_nature_qty_of_goods" className="form-label">Print 'Said To Contain' Above Goods Description</label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 row">
                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Print With Shipper's Address</h4>
                                        </div>
                                        <div className="col-md-12">
                                            <input type="checkbox" className="mx-2" name="is_print_shipper_phone" id="is_print_shipper_phone"
                                                checked={formik.values.is_print_shipper_phone}
                                                onChange={(e) => formik.setFieldValue("is_print_shipper_phone", e.target.checked)} />
                                            <label htmlFor="is_print_shipper_phone" className="form-label">Phone Number</label>
                                        </div>
                                        <div className="col-md-12">
                                            <input type="checkbox" className="mx-2" name="is_print_shipper_fax" id="is_print_shipper_fax"
                                                checked={formik.values.is_print_shipper_fax}
                                                onChange={(e) => formik.setFieldValue("is_print_shipper_fax", e.target.checked)} />
                                            <label htmlFor="is_print_shipper_fax" className="form-label">Fax Number</label>
                                        </div>
                                        <div className="col-md-12">
                                            <input type="checkbox" className="mx-2" name="is_print_shipper_email" id="is_print_shipper_email"
                                                checked={formik.values.is_print_shipper_email}
                                                onChange={(e) => formik.setFieldValue("is_print_shipper_email", e.target.checked)} />
                                            <label htmlFor="is_print_shipper_email" className="form-label">Email Id</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4 row">
                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Print With Consignee's Address</h4>
                                        </div>
                                        <div className="col-md-12">
                                            <input type="checkbox" className="mx-2" name="is_print_consignee_phone" id="is_print_consignee_phone"
                                                checked={formik.values.is_print_consignee_phone}
                                                onChange={(e) => formik.setFieldValue("is_print_consignee_phone", e.target.checked)} />
                                            <label htmlFor="is_print_consignee_phone" className="form-label">Phone Number</label>
                                        </div>
                                        <div className="col-md-12">
                                            <input type="checkbox" className="mx-2" name="is_print_consignee_fax" id="is_print_consignee_fax"
                                                checked={formik.values.is_print_consignee_fax}
                                                onChange={(e) => formik.setFieldValue("is_print_consignee_fax", e.target.checked)} />
                                            <label htmlFor="is_print_consignee_fax" className="form-label">Fax Number</label>
                                        </div>
                                        <div className="col-md-12">
                                            <input type="checkbox" className="mx-2" name="is_print_consignee_email" id="is_print_consignee_email"
                                                checked={formik.values.is_print_consignee_email}
                                                onChange={(e) => formik.setFieldValue("is_print_consignee_email", e.target.checked)} />
                                            <label htmlFor="is_print_consignee_email" className="form-label">Email Id</label>
                                        </div>
                                    </div>
                                    <div className="col-md-4 row">
                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Print With Notify's Address</h4>
                                        </div>
                                        <div className="col-md-12">
                                            <input type="checkbox" className="mx-2" name="is_print_notify_phone" id="is_print_notify_phone"
                                                checked={formik.values.is_print_notify_phone}
                                                onChange={(e) => formik.setFieldValue("is_print_notify_phone", e.target.checked)} />
                                            <label htmlFor="is_print_notify_phone" className="form-label">Phone Number</label>
                                        </div>
                                        <div className="col-md-12">
                                            <input type="checkbox" className="mx-2" name="is_print_notify_fax" id="is_print_notify_fax"
                                                checked={formik.values.is_print_notify_fax}
                                                onChange={(e) => formik.setFieldValue("is_print_notify_fax", e.target.checked)} />
                                            <label htmlFor="is_print_notify_fax" className="form-label">Fax Number</label>
                                        </div>
                                        <div className="col-md-12">
                                            <input type="checkbox" className="mx-2" name="is_print_notify_email" id="is_print_notify_email"
                                                checked={formik.values.is_print_notify_email}
                                                onChange={(e) => formik.setFieldValue("is_print_notify_email", e.target.checked)} />
                                            <label htmlFor="is_print_notify_email" className="form-label">Email Id</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Edit Shipper/Consignee/Notify Name & Address</h4>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-4">
                                            <input type="checkbox" className="mx-2" name="is_shipper_name_checked" id="is_shipper_name_checked"
                                                checked={formik.values.is_shipper_name_checked}
                                                onChange={(e) => formik.setFieldValue("is_shipper_name_checked", e.target.checked)} />
                                            <label htmlFor="is_shipper_name_checked" className="form-label">Shipper</label>


                                            <div className="input_box_section">

                                                <input
                                                    disabled={!formik.values.is_shipper_name_checked}
                                                    type="text"
                                                    name="shipper_name"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Shipper Name"
                                                    value={formik?.values?.shipper_name}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.shipper_name &&
                                                    formik?.errors.shipper_name ? (
                                                    <div className="error">
                                                        {formik?.errors.shipper_name}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <input type="checkbox" className="mx-2" name="is_shipper_address_checked" id="is_shipper_address_checked"
                                                checked={formik.values.is_shipper_address_checked}
                                                onChange={(e) => formik.setFieldValue("is_shipper_address_checked", e.target.checked)} />
                                            <label htmlFor="is_shipper_address_checked" className="form-label">Address</label>


                                            <div className="input_box_section">

                                                <input
                                                    disabled={!formik.values.is_shipper_address_checked}
                                                    type="text"
                                                    name="shipper_address"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Shipper's Address"
                                                    value={formik?.values?.shipper_address}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.shipper_address &&
                                                    formik?.errors.shipper_address ? (
                                                    <div className="error">
                                                        {formik?.errors.shipper_address}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-4">
                                            <input type="checkbox" className="mx-2" name="is_consignee_name_checked" id="is_consignee_name_checked"
                                                checked={formik.values.is_consignee_name_checked}
                                                onChange={(e) => formik.setFieldValue("is_consignee_name_checked", e.target.checked)} />
                                            <label htmlFor="is_consignee_name_checked" className="form-label">Consignee</label>


                                            <div className="input_box_section">

                                                <input
                                                    disabled={!formik.values.is_consignee_name_checked}
                                                    type="text"
                                                    name="consignee_name"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Consignee Name"
                                                    value={formik?.values?.consignee_name}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.consignee_name &&
                                                    formik?.errors.consignee_name ? (
                                                    <div className="error">
                                                        {formik?.errors.consignee_name}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <input type="checkbox" className="mx-2" name="is_consignee_address_checked" id="is_consignee_address_checked"
                                                checked={formik.values.is_consignee_address_checked}
                                                onChange={(e) => formik.setFieldValue("is_consignee_address_checked", e.target.checked)} />
                                            <label htmlFor="is_consignee_address_checked" className="form-label">Address</label>


                                            <div className="input_box_section">

                                                <input
                                                    disabled={!formik.values.is_consignee_address_checked}
                                                    type="text"
                                                    name="consignee_address"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Consignee's Address"
                                                    value={formik?.values?.consignee_address}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.consignee_address &&
                                                    formik?.errors.consignee_address ? (
                                                    <div className="error">
                                                        {formik?.errors.consignee_address}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-4">
                                            <input type="checkbox" className="mx-2" name="is_notify1_name_checked" id="is_notify1_name_checked"
                                                checked={formik.values.is_notify1_name_checked}
                                                onChange={(e) => formik.setFieldValue("is_notify1_name_checked", e.target.checked)} />
                                            <label htmlFor="is_notify1_name_checked" className="form-label">Notify1</label>


                                            <div className="input_box_section">

                                                <input
                                                    disabled={!formik.values.is_notify1_name_checked}
                                                    type="text"
                                                    name="notify1_name"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Notify1 Name"
                                                    value={formik?.values?.notify1_name}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.notify1_name &&
                                                    formik?.errors.notify1_name ? (
                                                    <div className="error">
                                                        {formik?.errors.notify1_name}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <input type="checkbox" className="mx-2" name="is_notify1_address_checked" id="is_notify1_address_checked"
                                                checked={formik.values.is_notify1_address_checked}
                                                onChange={(e) => formik.setFieldValue("is_notify1_address_checked", e.target.checked)} />
                                            <label htmlFor="is_notify1_address_checked" className="form-label">Address</label>


                                            <div className="input_box_section">

                                                <input
                                                    disabled={!formik.values.is_notify1_address_checked}
                                                    type="text"
                                                    name="notify1_address"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Notify1's Address"
                                                    value={formik?.values?.notify1_address}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.notify1_address &&
                                                    formik?.errors.notify1_address ? (
                                                    <div className="error">
                                                        {formik?.errors.notify1_address}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 row">
                                        <div className="col-md-4">
                                            <input type="checkbox" className="mx-2" name="is_notify2_name_checked" id="is_notify2_name_checked"
                                                checked={formik.values.is_notify2_name_checked}
                                                onChange={(e) => formik.setFieldValue("is_notify2_name_checked", e.target.checked)} />
                                            <label htmlFor="is_notify2_name_checked" className="form-label">Notify2</label>


                                            <div className="input_box_section">

                                                <input
                                                    disabled={!formik.values.is_notify2_name_checked}
                                                    type="text"
                                                    name="notify2_name"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Notify2 Name"
                                                    value={formik?.values?.notify2_name}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.notify2_name &&
                                                    formik?.errors.notify2_name ? (
                                                    <div className="error">
                                                        {formik?.errors.notify2_name}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <input type="checkbox" className="mx-2" name="is_notify2_address_checked" id="is_notify2_address_checked"
                                                checked={formik.values.is_notify2_address_checked}
                                                onChange={(e) => formik.setFieldValue("is_notify2_address_checked", e.target.checked)} />
                                            <label htmlFor="is_notify2_address_checked" className="form-label">Address</label>


                                            <div className="input_box_section">

                                                <input
                                                    disabled={!formik.values.is_notify2_address_checked}
                                                    type="text"
                                                    name="notify2_address"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Notify2's Address"
                                                    value={formik?.values?.notify2_address}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.notify2_address &&
                                                    formik?.errors.notify2_address ? (
                                                    <div className="error">
                                                        {formik?.errors.notify2_address}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <div className="row">
                                    <div className="col-md-6 row">


                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Charges Code</h4>
                                        </div>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="col-md-12"><input type='radio' className='me-2' value="dont_print" id="dont_print" onChange={() => { formik.setFieldValue("chargeCode", "dont_print") }} checked={formik.values.chargeCode === "dont_print"} /> <label className="form-label" htmlFor='dont_print'>Don't Print Charge Code and Mark With C Or P For Each Charge</label></div>
                                                <div className="col-md-12"><input type='radio' className='me-2' value="print_with_x" id="print_with_x" onChange={() => { formik.setFieldValue("chargeCode", "print_with_x") }} checked={formik.values.chargeCode === "print_with_x"} /> <label className="form-label" htmlFor='print_with_x'>Print Charge Code and Mark With X For Each Charge</label></div>
                                                <div className="col-md-12"><input type='radio' className='me-2' value="none" id="none" onChange={() => { formik.setFieldValue("chargeCode", "none") }} checked={formik.values.chargeCode === "none"} /> <label className="form-label" htmlFor='none'>None</label></div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-4 row">
                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Other Charges</h4>
                                        </div>
                                        <div className="col-md-12">


                                            <input type="checkbox" className="mx-2" name="is_print_other_charge_in_decimal" id="is_print_other_charge_in_decimal"
                                                checked={formik.values.is_print_other_charge_in_decimal}
                                                onChange={(e) => formik.setFieldValue("is_print_other_charge_in_decimal", e.target.checked)} />
                                            <label htmlFor="is_print_other_charge_in_decimal" className="form-label">Print Other Charges In Decimal Format</label>
                                        </div>
                                        <div className="col-md-12">
                                            <input type="checkbox" className="mx-2" name="is_print_clubbed_charges_in_master" id="is_print_clubbed_charges_in_master"
                                                checked={formik.values.is_print_clubbed_charges_in_master}
                                                onChange={(e) => formik.setFieldValue("is_print_clubbed_charges_in_master", e.target.checked)} />
                                            <label htmlFor="is_print_clubbed_charges_in_master" className="form-label">Print Clubbed Charges in Master</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 row">


                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Notify</h4>
                                        </div>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="col-md-12"><input type='radio' className='me-2' value="notify_handling_info_box" id="notify_handling_info_box" onChange={() => { formik.setFieldValue("notify_check_box", "notify_handling_info_box") }} checked={formik.values.notify_check_box === "notify_handling_info_box"} /> <label className="form-label" htmlFor='notify_handling_info_box'>Add Notify to Handling Info Box</label></div>
                                                <div className="col-md-12"><input type='radio' className='me-2' value="notify_remarks_box" id="notify_remarks_box" onChange={() => { formik.setFieldValue("notify_check_box", "notify_remarks_box") }} checked={formik.values.notify_check_box === "notify_remarks_box"} /> <label className="form-label" htmlFor='notify_remarks_box'>Add Notify To Remarks Box</label></div>
                                                <div className="col-md-12"><input type='radio' className='me-2' value="notify_accnt_info_box" id="notify_accnt_info_box" onChange={() => { formik.setFieldValue("notify_check_box", "notify_accnt_info_box") }} checked={formik.values.notify_check_box === "notify_accnt_info_box"} /> <label className="form-label" htmlFor='notify_accnt_info_box'>Add Notify To Account Info Box</label></div>
                                                <div className="col-md-12"><input type='radio' className='me-2' value="none" id="none" onChange={() => { formik.setFieldValue("notify_check_box", "none") }} checked={formik.values.notify_check_box === "none"} /> <label className="form-label" htmlFor='none'>None</label></div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-4 row">
                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Rating Box</h4>
                                        </div>
                                        <div className="col-md-12">
                                        <input type="checkbox" className="mx-2" name="is_print_remarks_below_rating" id="is_print_remarks_below_rating"
                                            checked={formik.values.is_print_remarks_below_rating}
                                            onChange={(e) => formik.setFieldValue("is_print_remarks_below_rating", e.target.checked)} />
                                        <label htmlFor="is_print_remarks_below_rating" className="form-label">Print Remarks Below Rating Line</label>
                                        </div>
                                        <div className="col-md-12">
                                        <input type="checkbox" className="mx-2" name="is_print_vol_with_dim" id="is_print_vol_with_dim"
                                            checked={formik.values.is_print_vol_with_dim}
                                            onChange={(e) => formik.setFieldValue("is_print_vol_with_dim", e.target.checked)} />
                                        <label htmlFor="is_print_vol_with_dim" className="form-label">Print Volume Weight With Dimension
                                        </label>
                                        </div>

                                    </div>
                                    <div className="col-md-4">
                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">As Agreed</h4>
                                        </div>
                                        <div className="card">

                                            <div className="card-body">
                                                <div className="col-md-12"><input type='radio' className='me-2' value="FREIGHT" id="FREIGHT" onChange={() => { formik.setFieldValue("as_agreed", "FREIGHT") }} checked={formik.values.as_agreed === "FREIGHT"} /> <label className="form-label" htmlFor='FREIGHT'>Only for Freight Rate</label></div>
                                                <div className="col-md-12"><input type='radio' className='me-2' value="ALL_CHARGES" id="ALL_CHARGES" onChange={() => { formik.setFieldValue("as_agreed", "ALL_CHARGES") }} checked={formik.values.as_agreed === "ALL_CHARGES"} /> <label className="form-label" htmlFor='ALL_CHARGES'>For all Charges</label></div>
                                                <div className="col-md-12"><input type='radio' className='me-2' value="NONE" id="NONE" onChange={() => { formik.setFieldValue("as_agreed", "NONE") }} checked={formik.values.as_agreed === "NONE"} /> <label className="form-label" htmlFor='NONE'>None</label></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="main-nav-det">
                                        <h4 className="form-heading-bg">Print Setting</h4>
                                    </div>
                                    <div className="col-md-6">
                                        <input type="checkbox" className="mx-2" name="is_print_executed_at" id="is_print_executed_at"
                                            checked={formik.values.is_print_executed_at}
                                            onChange={(e) => formik.setFieldValue("is_print_executed_at", e.target.checked)} />
                                        <label htmlFor="is_print_executed_at" className="form-label">Include 'EXECUTED AT' in Print</label>
                                    </div>
                                    <div className="col-md-6">
                                        <input type="checkbox" className="mx-2" name="is_print_airway_bill_num" id="is_print_airway_bill_num"
                                            checked={formik.values.is_print_airway_bill_num}
                                            onChange={(e) => formik.setFieldValue("is_print_airway_bill_num", e.target.checked)} />
                                        <label htmlFor="is_print_airway_bill_num" className="form-label">Print AirWay Bill Number
                                        </label>
                                    </div>
                                    <div className="col-md-6">
                                        <input type="checkbox" className="mx-2" name="is_print_this_handling_info" id="is_print_this_handling_info"
                                            checked={formik.values.is_print_this_handling_info}
                                            onChange={(e) => { formik.setFieldValue("is_print_this_handling_info", e.target.checked); setThisHandlingInfo(e.target.checked) }} />
                                        <label htmlFor="is_print_this_handling_info" className="form-label">Print this Handling Info</label>
                                    </div>
                                    {/* {thisHandlingInfo && */}
                                    <div className="col-md-6">
                                        <div className="input_box_section ">
                                            {/* <label
                                                        for="basicpill-firstname-input"
                                                        className="form-label"
                                                    >
                                                        Port Of Loading Code 
                                                    </label> */}
                                            <input
                                                disabled={!formik.values.is_print_this_handling_info}
                                                type="text"
                                                name="handling_info"
                                                className="form-control form-control-sm"
                                                placeholder="Enter Handling Info"
                                                value={formik?.values?.handling_info}
                                                onChange={formik?.handleChange}
                                                onBlur={formik?.handleBlur}

                                                onKeyPress={(event) => {
                                                    const inputValue = event.target.value;
                                                    if (
                                                        inputValue.length === 0 &&
                                                        event.key === " "
                                                    ) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                            />
                                            {formik?.touched.handling_info &&
                                                formik?.errors.handling_info ? (
                                                <div className="error">
                                                    {formik?.errors.handling_info}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    {/* } */}
                                    <div className="col-md-6">
                                        <input type="checkbox" className="mx-2" name="is_print_setting_eap" id="is_print_setting_eap"
                                            checked={formik.values.is_print_setting_eap}
                                            onChange={(e) => formik.setFieldValue("is_print_setting_eap", e.target.checked)} />
                                        <label htmlFor="is_print_setting_eap" className="form-label">EAP
                                        </label>
                                    </div>
                                    <div className="col-md-6">
                                        <input type="checkbox" className="mx-2" name="is_print_setting_eaw" id="is_print_setting_eaw"
                                            checked={formik.values.is_print_setting_eaw}
                                            onChange={(e) => formik.setFieldValue("is_print_setting_eaw", e.target.checked)} />
                                        <label htmlFor="is_print_setting_eaw" className="form-label">EAW</label>
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-4 row">


                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Dimension</h4>
                                        </div>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="col-md-12"><input type='radio' className='me-2' value="dimension_below_rating" id="dimension_below_rating" onChange={() => { formik.setFieldValue("dimension_check_box", "dimension_below_rating") }} checked={formik.values.dimension_check_box === "dimension_below_rating"} /> <label className="form-label" htmlFor='dimension_below_rating'>Add Dimension below Rating Line</label></div>
                                                <div className="col-md-12"><input type='radio' className='me-2' value="dimension_below_goods_box" id="dimension_below_goods_box" onChange={() => { formik.setFieldValue("dimension_check_box", "dimension_below_goods_box") }} checked={formik.values.dimension_check_box === "dimension_below_goods_box"} /> <label className="form-label" htmlFor='dimension_below_goods_box'>Add Dimension below Goods Description</label></div>
                                                <div className="col-md-12"><input type='radio' className='me-2' value="dimension_accnt_info_box" id="dimension_accnt_info_box" onChange={() => { formik.setFieldValue("dimension_check_box", "dimension_accnt_info_box") }} checked={formik.values.dimension_check_box === "dimension_accnt_info_box"} /> <label className="form-label" htmlFor='dimension_accnt_info_box'>Add Dimension in Account Info</label></div>
                                                <div className="col-md-12"><input type='radio' className='me-2' value="none" id="none" onChange={() => { formik.setFieldValue("dimension_check_box", "none") }} checked={formik.values.dimension_check_box === "none"} /> <label className="form-label" htmlFor='none'>None</label></div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-4 row">


                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Origin Port Option</h4>
                                        </div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="city" id="city" onChange={() => { formik.setFieldValue("origin_port_opt", "city"); setOriginOptnAirport(false) }} checked={formik.values.origin_port_opt === "city"} /> <label className="form-label" htmlFor='city'>City</label></div>
                                        <div className="col-md-6"><input type='radio' className='me-2' value="airport" id="airport" onChange={() => { formik.setFieldValue("origin_port_opt", "airport"); setOriginOptnAirport(true) }} checked={formik.values.origin_port_opt === "airport"} /> <label className="form-label" htmlFor='airport'>Airport</label></div>
                                        {/* {originOptnAirport && */}
                                            <div className="col-md-12">
                                                <div className="input_box_section ">
                                                    {/* <label
                                                        for="basicpill-firstname-input"
                                                        className="form-label"
                                                    >
                                                        Port Of Loading Code 
                                                    </label> */}
                                                    <input
                                                    disabled={formik.values.origin_port_opt != "airport"}
                                                        type="text"
                                                        name="origin_airport"
                                                        className="form-control form-control-sm"
                                                        placeholder="Enter Airport Name"
                                                        value={formik?.values?.origin_airport}
                                                        onChange={formik?.handleChange}
                                                        onBlur={formik?.handleBlur}

                                                        onKeyPress={(event) => {
                                                            const inputValue = event.target.value;
                                                            if (
                                                                inputValue.length === 0 &&
                                                                event.key === " "
                                                            ) {
                                                                event.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                    {formik?.touched.origin_airport &&
                                                        formik?.errors.origin_airport ? (
                                                        <div className="error">
                                                            {formik?.errors.origin_airport}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        {/* } */}

                                    </div>
                                    <div className="col-md-4 row">
                                        <div className="main-nav-det">
                                            <h4 className="form-heading-bg">Mawb Issued Option</h4>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    Party 
                                                </label>
                                                <input
                                                    type="text"
                                                    name="mawb_issued_party"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter Party"
                                                    value={formik?.values?.mawb_issued_party}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.mawb_issued_party &&
                                                    formik?.errors.mawb_issued_party ? (
                                                    <div className="error">
                                                        {formik?.errors.mawb_issued_party}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="input_box_section ">
                                                <label
                                                    for="basicpill-firstname-input"
                                                    className="form-label"
                                                >
                                                    City 
                                                </label>
                                                <input
                                                    type="text"
                                                    name="mawb_issued_city"
                                                    className="form-control form-control-sm"
                                                    placeholder="Enter City"
                                                    value={formik?.values?.mawb_issued_city}
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}

                                                    onKeyPress={(event) => {
                                                        const inputValue = event.target.value;
                                                        if (
                                                            inputValue.length === 0 &&
                                                            event.key === " "
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {formik?.touched.mawb_issued_city &&
                                                    formik?.errors.mawb_issued_city ? (
                                                    <div className="error">
                                                        {formik?.errors.mawb_issued_city}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>



                                    </div>
                                </div>

                                <div className="row d-flex justify-content-end mt-2">
                                    <div className="col-md-6 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Download"}
                                        </button>
                                    </div>
                                </div>
                            </form>}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AEDirectMAWBDownloadOptionsModal